import ErrorComponent from "../ErrorComponent/ErrorComponent";
import React from "react";
import PropTypes from "prop-types";

const InputGroup = (props) => {
  return (
    <div className={`form-field ${props.error ? 'has-error' : ''} ${props.className || ''}`}>
      <div className={`form-field-wrapper ${props.topLabel ? 'top-label' : ''}`}>
        {props.children}
        {props.topLabel && (<label htmlFor={props.id}>{props.label}</label>)}
      </div>
      <ErrorComponent error={props.error}/>
    </div>
  );
};
InputGroup.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  topLabel: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};

export default InputGroup;